import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { CoOwner, Encumbrance } from 'types';

import ShareEncumbranceViewTableRow from './ShareEncumbranceViewTableRow';
import NoItemsAvailable from '../../../EmptyStates/NoItemsAvailable';

type Props = {
  encumbrances: Encumbrance[];
  isEditing: boolean;
  isReadOnly?: boolean;
  mainCoOwner: CoOwner;
  // eslint-disable-next-line no-unused-vars
  handleEditEncumbrance: (index: number) => void;
  // eslint-disable-next-line no-unused-vars
  handleRemoveEncumbrance: (index: number) => void;
};

const ShareEncumbranceViewTableBody: FC<Props> = ({
  encumbrances,
  isEditing,
  isReadOnly,
  mainCoOwner,
  handleEditEncumbrance,
  handleRemoveEncumbrance,
}) => {
  const { t } = useTranslate();

  const hasData = encumbrances?.length > 0;

  return (
    <tbody>
      {hasData ? (
        encumbrances?.map((encumbrance: Encumbrance, index: number) => (
          <ShareEncumbranceViewTableRow
            index={index}
            encumbrance={encumbrance}
            isEditing={isEditing}
            isReadOnly={isReadOnly}
            mainCoOwner={mainCoOwner}
            handleEditEncumbrance={handleEditEncumbrance}
            handleRemoveEncumbrance={handleRemoveEncumbrance}
          />
        ))
      ) : (
        <NoItemsAvailable mainMessage={t('NoEncumbrancesMessage')} />
      )}
    </tbody>
  );
};

export default ShareEncumbranceViewTableBody;
